export class OutputsDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class OutputUpdateAndSaveState extends OutputsDispatcher {
    constructor() {
        super();
    }
}
export class OutputChange extends OutputsDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class OutputAddNewState extends OutputsDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class OutputAddNewSurvey extends OutputsDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
